// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"212":"e86e0daa","286":"5253da81","366":"eb24fc9a","445":"97c1e27f","602":"92fc6122","612":"1bb3ba38","842":"5c1590eb","974":"71d1ef35"}[chunkId] + ".chunk.js";
};